<template>
  <div>
    <vs-card
      ><ListMotivosEvento
        :subjectPermission="subjectPermission"
      ></ListMotivosEvento
    ></vs-card>
  </div>
</template>
<script>
import ListMotivosEvento from '../motivos-evento/motivos-evento-data-list.vue';

export default {
  components: {
    ListMotivosEvento,
  },
  data() {
    return {
      subjectPermission: 'Motivo de Evento',
    };
  },
};
</script>
<style></style>
